<template>
  <footer class="container footer">
    <div class="footer__logo">
      <img class="" src="../assets/images/parker-logo.svg" alt="logo parker">
    </div>
    <div class="footer__logos">
      <img class="" src="../assets/images/logos.svg" alt="logos">
    </div>
  </footer>
</template>

<script>
  export default {
    name: "FooterComponent"
  }
</script>

<style lang="scss">
  .footer {
    margin-top: 50px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    &__logo {
      max-width: 40%;

      & > img {
        max-width: 100%;
      }
    }

    &__logos {
      max-width: 40%;

      & > img {
        max-width: 100%;
      }
    }
  }

  @media (max-width: 992px) {
    .footer {
      &__logo {
        margin: 0 20px;
        max-width: 40%;

        & > img {
          max-width: 100%;
        }
      }

      &__logos {
        margin: 0 20px;
        max-width: 40%;

        & > img {
          max-width: 100%;
        }
      }
    }
  }

</style>